import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, Input, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createWorker } from 'tesseract.js';
let cv = (window as any).cv;

@Component({
  selector: 'app-visualizador-img-dialog',
  templateUrl: './visualizador-img-dialog.component.html',
  styleUrls: ['./visualizador-img-dialog.component.scss']
})
export class VisualizadorImgDialogComponent implements OnInit {
  
  indexSeleccionado = 0
  imagenes = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  private cdRef: ChangeDetectorRef, public dialogRef: MatDialogRef<VisualizadorImgDialogComponent>){
    // this.indexSeleccionado = data.indexSelected
    // this.imagenes = data.imgs
  }
  
  ngOnInit() {
    this.indexSeleccionado = this.data.indexSelected;
    this.imagenes = this.data.imgs;

    console.log('Imagenes cargadas:', this.imagenes.length);

    // Forzar que Angular vuelva a evaluar el template
    this.cdRef.detectChanges();
  } 

  cerrarDialog(){
    this.dialogRef.close({event: 2})
  }
  
  next(){
    this.indexSeleccionado = this.indexSeleccionado + 1
  }

  previous(){
    this.indexSeleccionado  = this.indexSeleccionado - 1
  }

  disabledPrevious(){
    return this.indexSeleccionado === 0
  }

  disabledNext(){
    return this.indexSeleccionado < (this.imagenes.length - 1)
  }

  getLongitud(){
    console.log('ENTRO A VALIDAR', this.imagenes.length > 1)
    return this.data.imgs > 1
  }

  getImgTitle(img){
    if(img.includes('img_ine')){
      return 'Evidencia Identificación'
    }else if(img.includes('img_tacometro')){
      return 'Evidencia Tacómetro'
    }else if(img.includes('img_placas')){
      return 'Evidencia Placas'
    }else if(img.includes('img_noSerie')){
      return 'Evidencia Número de Serie'
    }else if(img.includes('img_piso_llanta')){
      return 'Evidencia Llanta Piso'
    }else if(img.includes('img_perfil_llanta')){
      return 'Evidencia Llanta Perfil'
    }else if(img.includes('img_danio_llanta')){
      return 'Evidencia Área Dañada'
    }else{
      return ''
    }
  }
}
